import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '0px 32px 32px',
    flexDirection: 'column',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px 0px 10px 0px',
  },
  subcontainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '38px 22px 12px',
    marginBottom: '30px',
    flexDirection: 'column',
    border: '1px solid #E3E3E3',
    borderRadius: '8px',
    gap: '24px',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    alignItems: 'start',
    marginRight: 'auto',
    width: '100%',
    gap: '44px',
    position: 'relative',
  },
  wrapperFull: {
    width: '100%',
    position: 'relative',
  },
  label: {
    top: '-8px',
    left: '14px',
    padding: '0px 6px',
    position: 'absolute',
    backgroundColor: 'white',
  },
  inputLabel: {
    color: 'black !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    display: 'flex',
    gap: '4px',
  },
  checkboxField: {
    marginTop: '-10px',
    marginLeft: spacing(5),
  },
  fullWidth: {
    gridColumn: '1 / -1',
  },
  moSwitchWrapper: {
    width: '100%',
  },
  moSwitchLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing(0.5),
    color: 'black',
    fontSize: '12px',
    fontWeight: 500,
  },
  moSwitchHelpIcon: {
    fontSize: '18px',
  },
  moRangesContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
    marginTop: spacing(1.5),
  },
  moRangesHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(1),
    marginBottom: spacing(1.5),
  },
  moRangesTitle: {
    position: 'static',
    transform: 'none',
    display: 'block',
    lineHeight: 1.4,
    color: 'black',
    fontSize: '12px',
    fontWeight: 500,
  },
  moRangesRows: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
    marginTop: spacing(3),
  },
  moRangesRowsReadOnly: {
    marginTop: spacing(10),
  },
  moRangesRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr)) auto',
    columnGap: spacing(4),
    alignItems: 'start',
  },
  moRangesRowReadOnly: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  moRemoveLineButton: {
    marginTop: spacing(3),
    minWidth: 'fit-content',
    color: '#C90000',
    padding: '4px 8px',
  },
}))
